import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-login',
  imports: [],
  templateUrl: './login.html',
  styleUrl: './login.scss'
})
export class Login {


  silverpushLogo = 'assets/img/logo.svg';
  googleLogo = 'assets/img/google.svg'
  cntLogo = 'assets/img/cnt.svg'

  constructor(){

  }


  signInWithGoogle(){
    window.open(`${environment.apiBaseUrl}/auth/google`, '_self')
  }

}



